<template>
<div class="content-area">
  <slot />
</div>
</template>

<script>
export default {
  name: 'ContentArea'
}
</script>

<style scoped lang="scss">
.content-area {
  flex: 1.5;

  padding: 0 0 40px 0;
}
@media only screen and (min-width: 769px) {
    .content-area {
        width: 60%;
        padding: 0 100px 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ContentArea.vue